import { useMsal } from '@azure/msal-react'
import { loginRequest } from '../auth/authConfig'

function LoginPage() {
    const { instance } = useMsal()

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch((error) => {
            console.error('Login error:', error)
        })
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-aviator-600 to-aviator-900">
            <div className="max-w-md w-full mx-4">
                {/* Login Card */}
                <div className="bg-white rounded-2xl shadow-2xl p-8">
                    {/* Logo / Brand */}
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-gray-900">
                            Aviator Energy
                        </h1>
                        <p className="text-gray-500 mt-2">
                            Investor Portal
                        </p>
                    </div>

                    {/* Welcome Message */}
                    <div className="text-center mb-8">
                        <h2 className="text-xl font-semibold text-gray-800">
                            Welcome Back
                        </h2>
                        <p className="text-gray-500 mt-2 text-sm">
                            Sign in to access your investor dashboard
                        </p>
                    </div>

                    {/* Sign In Button */}
                    <button
                        onClick={handleLogin}
                        className="w-full bg-aviator-600 hover:bg-aviator-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200 flex items-center justify-center space-x-2"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <span>Sign In</span>
                    </button>

                    {/* Divider */}
                    <div className="relative my-6">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-200"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-white text-gray-500">
                                Secure Authentication
                            </span>
                        </div>
                    </div>

                    {/* Info */}
                    <p className="text-center text-xs text-gray-400">
                        Access is restricted to authorized investors only.
                        <br />
                        Contact Aviator Energy for access requests.
                    </p>
                </div>

                {/* Footer */}
                <p className="text-center text-white/60 text-sm mt-6">
                    &copy; {new Date().getFullYear()} Aviator Energy
                </p>
            </div>
        </div>
    )
}

export default LoginPage
